export const iconPositions = ["start", "end"];
export type IconPosition = "start" | "end";

export type BlockItemProps = {
	className?: string;
	mediaPriority?: boolean;
	mediaSizes?: string;
};
